import gsap, { Power3, Linear } from "gsap/all";
import $ from "jquery";

gsap.registerPlugin(Power3, Linear);

/*----------------------------------------------------*/
/* PRELOADER
/*----------------------------------------------------*/
$(document).ready(function() {
    function preloader(){

        var progressBar = $(".progress");
        var percentageText = $(".percentage");

        var tl = gsap.timeline({
            onComplete: function() {
                $('html').removeClass('loading');
            }
        });

        tl.to(progressBar, { height: "100%", duration: 2.5, delay:1, ease: "power1.out" })
            .to(percentageText, { text: "100%", duration: 2 }, "-=2")
            .to("#preloader", {y:'-101%', display: "none", duration: 1, ease: "Expo.easeInOut" }, "+=0.5");
        
        var count = { value: 0 };
        gsap.to(count, {
            value: 100,
            duration: 2.5,
            onUpdate: function() {
                percentageText.text(Math.round(count.value) + "%");
            },
            delay: 1
        });
    }

    preloader();
})